import React from 'react';
import { START, QUOTED, PRICE_SELECTED, ERROR } from 'pu-data/QuoteSteps';

class ProductCartForm extends React.Component {
  static isValid() {
    if (!jQuery('#quote_form').valid()) {
      vfShowModalErrors('One or more required fields are missing');
      vfScrollToError();
      return false;
    }
    return true;
  }

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.onAddToCart = this.onAddToCart.bind(this);
    this.checkErrors = this.checkErrors.bind(this);
  }

  onClick() {
    if (!this.onAddToCart()) { return; }
    jQuery('#quote_form').submit();
  }

  onAddToCart() {
    if (!this.checkErrors()) { return false; }
    if (!ProductCartForm.isValid()) { return false; }
    if (this.addtionalValidations) {
      if (!this.addtionalValidations()) {
        return false;
      }
    }
    return true;
  }

  checkErrors() {
    const errors = [];
    if (this.props.quoteStep === START) {
      errors.push('Fill the form and get a quote before add to cart');
    } else if (this.props.useButtonQuote && this.props.parametersChanged === true) {
      errors.push('One or more parameters have changed. Please get a new quote');
    } else if (this.props.usePriceMatrix && this.props.quoteStep === QUOTED) {
      errors.push('You must select a price from the price matrix before adding to the cart.');
    } else if (this.props.quoteStep === ERROR) {
      errors.push('Our most sincere apologies something went wrong, please contact the administrator');
    } else {
      let projectType = 'board';
      if (this.props.projectType === 'stencil') projectType = 'stencil';

      if (!jQuery('#part-number').valid()) {
        errors.push(`Please enter the ${projectType} name/part number.`);
      }
      const revision = jQuery('#revision');
      if (revision.length && !revision.valid()) {
        errors.push(`Please enter the ${projectType} revision.`);
      }

      if (this.props.usePriceMatrix && jQuery('input[name="parameters[price_matrix]"]:checked').length === 0) {
        errors.push('Please select a price from one of the matrices below');
      }
    }

    if (errors.length > 0) {
      vfShowModalErrors(errors);
      // alert(errors);
      return false;
    }
    return true;
  }

  render() {
    const properties = this.props.properties || [];
    const { unitPrice, totalPrice } = this.props;
    return (
      <div className="inside-product-cart">
        <span className="selection-label">Pricing Information</span>
        <hr className="qty-separator" />
        {properties.map((p, idx) => (
          <div key={idx} className="row g-0 align-items-center mb-1 product-property">
            <div className="col-auto">
              <span className="product-property-label">{p.label}</span>
            </div>
            <div className="col-auto">
              <span className="product-property-value">{p.value}</span>
            </div>
          </div>
        ))}
        <hr className="product-unit-price-separator" />
        <span>Unit Price:</span> <span className="product-unit-price" >{unitPrice}</span>
        <hr className="product-total-separator" />
        <span className="product-total-label">Total:</span> <span className="product-total">{totalPrice}</span>
        <div className="text-center">
          <input type="button" className="btn btn-round btn-main-action" onClick={this.onClick} value="Add To Cart" />
        </div>
      </div>
    );
  }
}

ProductCartForm.defaultProps = {
  usePriceMatrix: true,
  useButtonQuote: true,
  projectType: 'pcb',
};

export default ProductCartForm;
